import { Mail, Home } from "heroicons-react";
import { Twitter, Instagram } from "../../../../src/components/icons";
import * as React from 'react';
export default {
  Mail,
  Home,
  Twitter,
  Instagram,
  React
};